const InputLabel = __NATIVE__
  ? require('./native').default
  : require('./dom').default;

export default InputLabel;
